<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Items</li>
            </ol>
            <h4 class="main-title mb-2">Items</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'item.create'">
                <form>
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Item</h6>
                            <h6 class="card-title" v-else>Update Item</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Category</label><span class="text-danger"> *</span>
                                    <select class="form-control" :class="{ 'is-invalid': errors.category_id }" v-model="item.category_id" ref="category_id">
                                        <option value="">Select Category</option>
                                        <option v-for="category, key in categories" :key="key" :value="category.category_id"> {{ category.category_name }}</option>
                                    </select>
                                    <span v-if="errors.category_id"><small class="text-danger">{{ errors.category_id[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Item Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Item Code" class="form-control" :class="{ 'is-invalid': errors.item_code }" v-model="item.item_code" ref="item_code" />
                                    <span v-if="errors.item_code"><small class="text-danger">{{ errors.item_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Item Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Item" class="form-control" :class="{ 'is-invalid': errors.item_name }" v-model="item.item_name" />
                                    <span v-if="errors.item"><small class="text-danger">{{ errors.item[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" @click="submitForm()">
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Items</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort(category_id)">Category
                                            <span>
                                                <i v-if="meta.keyword=='category_id' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='category_id' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                        <th @click="sort('item_code')">Item Code
                                            <span>
                                                <i v-if="meta.keyword=='item_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='item_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                        <th @click="sort('item_name')">Item Name
                                        
                                            <span>
                                                <i v-if="meta.keyword=='item_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='item_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                       
                                        <th class="text-center" v-can="'item.delete'">Status</th>
                                        <th class="text-center" v-can="'item.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="items.length==0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="item, key in items" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ item.category.category_name}}</td>
                                        <td>{{ item.item_code }}</td>
                                        <td>{{ item.item_name }}</td>
                                        <td class="text-center" v-can="'item.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'item' + item.item_id" :checked="item.status" :value="item.status" @change="deleteItem(item)" />
                                                <label class="custom-control-label" :for="'item' + item.item_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'item.update'">
                                            <a href="javascript:void(0)" v-if="item.status" class="text-success me-2" @click="editItem(item)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column: 'col-8',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "item_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                item: {
                    item_id: "",
                    category_id:"",
                    item_code: "",
                    item_name: "",
                },
                status: true,
                items: [],
                errors: [],
                //categories:[]
            };
        },
        mounted() {
            this.create_item = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('item.create')
            })
            if(this.create_item.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.getCategories();
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addItem();
                } else {
                    vm.updateItem();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateItems", data: vm.meta })
                    .then((response) => {

                        vm.items = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addItem() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addItem", data: vm.item })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Item Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getCategories() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getCategories" })
                    .then((response) => {
                        loader.hide();
                        vm.categories = response.data.data
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateItem() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateItem", data: vm.item })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Item is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editItem(item) {
                let vm = this;
                vm.$refs.item_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.item = item;
            },

            deleteItem(item) {
                let vm = this;
                let loader = vm.$loading.show();
                item.status = item.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deleteItem", data: item })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getCategories() {
            let vm = this;
            let loader = this.$loading.show();
            this.$store.dispatch('post', { uri: 'getCategories' })
                .then(response => {
                    loader.hide();
                    this.categories = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
            let vm = this;
            vm.item.category_id = "";
            vm.item.item_code = "";
            vm.item.item_name = "";
            vm.$refs.item_code.focus();
            vm.errors = [];
            vm.status = true;
            vm.index();
        },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            
        },
    };
</script>
